<template>
  <div class="r-address" @click="detail">
    <div class="r-address-img">
      <img :src="config.expressUrl" alt="">
    </div>
    <div class="name">{{config.contact}}</div>
    <div class="tel">{{config.phone}}</div>
    <div class="detail">
      {{config.address}}
    </div>
    <div class="add" v-if="config.isDefault==1"> <span>{{$t('address.defaultAdd')}}</span> </div>
    <div class="add common-hover" @click.stop="setDefault" style="color:#999" v-else> <span>{{$t('address.setDefault')}}</span> </div>
    <div class="type"> <span> {{config.expressName}}</span> / <span>{{config.expressTypeName}}</span> / <span>{{config.payTypeName}}</span> </div>
    <div class="common-flex common-justify-between options">
      <div class="common-hover" @click.stop="edit"><span class="iconfont iconbianji"></span> {{$t('address.edit')}}</div>
      <div class="common-hover" @click.stop="del"><span class="iconfont iconshanchudizhi"></span>{{$t('address.delete')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "r-address",
  data() {
    return {};
  },
  props:{
    config:Object
  },
  methods:{
    // 删除
    del(){
      this.$emit('del',this.config)
    },
    // 编辑
    edit(){
      this.$emit('edit',this.config)
    },
    // 详情
    detail(){
      this.$emit('detail',this.config)
    },
    // 设置默认
    setDefault(){
      this.$emit('setDefault',this.config)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-address {
  width: 325px;
  height: 220px;
  border: 1px solid #ced1d8;
  padding: 25px 10px 14px 10px;
  position: relative;
  font-family: Roboto;
  .r-address-img {
    width: 32px;
    height: 32px;
    // background: #f8f8f8;
    position: absolute;
    top: 10px;
    left: 10px;
    img{
          width: 32px;
    height: 32px;
    }
  }
  .name {
    opacity: 1;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: #081938;
    line-height: 16px;
    margin-bottom: 10px;
  }
  .tel {
    opacity: 1;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .detail {
    opacity: 0.4;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 17px;
    width: 220px;
    height: 34px;
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //当属性值为3，表示超出3行隐藏
    // margin-bottom: 18px;
    margin: 0 auto 18px;
  }
  .add {
    opacity: 1;
    font-size: 10px;
    font-weight: 400;
    text-decoration: underline;
    text-align: center;
    color: #0a4dcc;
    line-height: 11px;
    margin-bottom: 17px;
    height: 11px;
  }
  .type {
    width: 305px;
    height: 23px;
    background: #f2f6fc;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 23px;
    text-align: center;
    margin: 0 auto 13px;
  }
  .options {
    opacity: 0.7;
    font-size: 12px;
    font-weight: 400;
    text-align: right;
    color: #081938;
    line-height: 14px;
    .iconfont{
        font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-address.vue